import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import SitemarkIcon from '../SitemarkIcon';
import LanguageSelector from '../LanguageSelector';
import { Link as RouterLink } from "react-router-dom";

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
      {'Copyright © '}
      <Link color="text.secondary" href="https://www.kehilati.com/">
        Kehilati
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 2, sm: 4 },
        py: { xs: 2, sm: 4 },
        textAlign: 'center',
      }}
    >
      {/* Logo et liens principaux */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' }, // Empile les éléments sur mobile
          justifyContent: { xs: 'center', sm: 'space-between' },
          alignItems: 'center',
          width: '100%',
          gap: { xs: 2, sm: 4 },
          borderTop: '1px solid',
          borderColor: 'divider',
          pt: { xs: 2, sm: 4 },
        }}
      >
        <SitemarkIcon />
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            gap: 1,
            whiteSpace: 'nowrap',
          }}
        >
          <Link color="text.secondary" variant="body2" component={RouterLink} to="/privacy">
            Privacy Policy
          </Link>
          <Typography sx={{ mx: 0.5, opacity: 0.5 }}>&nbsp;•&nbsp;</Typography>
          <Link color="text.secondary" variant="body2" component={RouterLink} to="/terms">
            Terms of Service
          </Link>
          <Typography sx={{ mx: 0.5, opacity: 0.5 }}>&nbsp;•&nbsp;</Typography>
          <Link color="text.secondary" variant="body2" component={RouterLink} to="/refund">
            Refund Policy
          </Link>
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', mt: { xs: 1, sm: 0 } }}
          >
            Copyright © Kehilati {new Date().getFullYear()}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: { xs: 1, sm: 0 } }}>
          <LanguageSelector />
        </Box>
      </Box>
    </Container>
  );
}
